/**
 * Local IndexedDB (Dexie). One database per device (single-user model, wiped on user switch).
 * Stores are added by later milestones: annotations/layers/cursors/outbox (M4), packs (M5).
 */
import Dexie, { type Table } from 'dexie';

export interface OutboxItem {
  seq?: number; // auto-increment → FIFO order
  id: string; // client op id
  userId: string;
  kind: string; // e.g. 'annotation', 'layer', 'rsvp', 'checkin', 'comment'
  key: string; // collapse key (same object → replace payload, keep position)
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  path: string;
  body: unknown;
  createdAt: number;
  attempts: number;
  failed?: { status: number; code: string; at: number } | null;
}

export interface KvRow {
  k: string;
  v: unknown;
}

export class KgrDb extends Dexie {
  outbox!: Table<OutboxItem, number>;
  kv!: Table<KvRow, string>;

  constructor() {
    super('kgr');
    this.version(1).stores({
      outbox: '++seq, id, userId, key, kind',
      kv: 'k',
    });
  }
}

let instance: KgrDb | null = null;
export function localDb(): KgrDb {
  if (!instance) instance = new KgrDb();
  return instance;
}

export async function deleteLocalDb(): Promise<void> {
  if (instance) {
    instance.close();
    instance = null;
  }
  await Dexie.delete('kgr');
}
